import $ from 'jquery';
import throttle from 'lodash/throttle.js';

const TIMELINE_ITEM_CLASSNAME = "-highlighted";
const TIMELINE_FIXED_CLASSNAME = "fixed-bottom";
const JUMP_BTN_HIDDEN_CLASSNAME = "-hidden";
const JUMP_BTN_VISIBLE_CLASSNAME = "-visible";

const $window = $(window);
const $dateItemTiles = $('.ef-editorial-teaser');
const $timelineElements = $('.timeline__item');
const $timelineList = $('.editorial-history-footer__list.timeline');
const $jumpBtn = $('#editorial-history-jump-btn');
const $jumpBtnBottom = $('#editorial-history-jump-btn-to-bottom');
const $jumpBtnTop = $('#editorial-history-jump-btn-to-top');
const $page = $('#collection-teaser-editorial-history-container');
const $footer = $('#editorial-history-footer');

let activeIndex = null;

initIntersectionObservers();
initEventListener();
onChangeViewport();
initTimeline();

function initEventListener() {
  $window.on('scroll', throttle(onChangeViewport, 125));
  $window.on('resize', throttle(onChangeViewport, 125));
}

function onChangeViewport () {
  let pageTopY = $page.offset().top;
  let pageBottomY = pageTopY + $page.outerHeight();
  let footerHeight = $footer.outerHeight();
  let viewPortTopY = ($window.scrollTop());
  let viewPortBottomY = (viewPortTopY + $window.height());
  let jumpButtonBottomY = $jumpBtn.offset().top;
  let footerBottomY = $footer.offset().top;

  let isFooterAtBottom = (viewPortBottomY <= (pageBottomY + footerHeight));
  setTimelineFooterSticky(isFooterAtBottom);

  let isJumpButtonVisible = jumpButtonBottomY > pageTopY && jumpButtonBottomY < footerBottomY;
  setJumpButtonVisibility(isJumpButtonVisible);
  updateTimeline();
}

function findTopVisibleTile() {
  let viewPortTopY = ($window.scrollTop());
  let viewPortBottomY = (viewPortTopY + $window.height());
  let topVisibleTile = null;

  $dateItemTiles.each((index, tile) => {
    const $tile = $(tile);
    let tileTopY = $tile.offset().top;
    let tileMiddleY = tileTopY + ($tile.outerHeight() * 0.5);

    if ( (tileMiddleY > viewPortTopY && tileMiddleY < viewPortBottomY) && !topVisibleTile ) {
      topVisibleTile = tile;
    }

    activeIndex = $(topVisibleTile).attr('data-id') - 1;
  });
}

function initIntersectionObservers() {
  const options = {
    threshold: [0.1, 0.9]
  };

  const tileObserver = new IntersectionObserver((entries, observer) => onItemEnteredViewport(entries, observer), options);
  $dateItemTiles.toArray().forEach(item => tileObserver.observe(item));
}

function onItemEnteredViewport(entries) {
  findTopVisibleTile();
  updateTimeline();
  updateJumpButton();
}

function updateJumpButton() {
  const numberOfTiles = $dateItemTiles.length;
  const isJumpButtonDirectionDown = activeIndex < numberOfTiles / 2;

  if (isJumpButtonDirectionDown) {
    $jumpBtnBottom.removeClass(JUMP_BTN_HIDDEN_CLASSNAME);
    $jumpBtnTop.addClass(JUMP_BTN_HIDDEN_CLASSNAME);
  } else {
    $jumpBtnBottom.addClass(JUMP_BTN_HIDDEN_CLASSNAME);
    $jumpBtnTop.removeClass(JUMP_BTN_HIDDEN_CLASSNAME);
  }
}

function updateTimeline() {
  if (activeIndex === null) {
    initTimeline();
    return;
  }
  $timelineElements.removeClass(TIMELINE_ITEM_CLASSNAME);
  const $activeTimelineElement = $timelineElements.eq(activeIndex);
  $activeTimelineElement.addClass(TIMELINE_ITEM_CLASSNAME);
  let newPositionOffset = ((activeIndex + 1) * $activeTimelineElement.outerWidth() ) - $activeTimelineElement.outerWidth() / 2;
  $timelineList.css('margin-left', `${ (window.innerWidth / 2) - newPositionOffset }px`);
}

function initTimeline() {
  let newPositionOffset = $timelineElements.first().outerWidth() / 2;
  $timelineList.css('margin-left', `${ (window.innerWidth / 2) - newPositionOffset }px`);
}

function setTimelineFooterSticky(shouldBeSticky) {
  if (shouldBeSticky) {
    $footer.addClass(TIMELINE_FIXED_CLASSNAME);
  } else {
    $footer.removeClass(TIMELINE_FIXED_CLASSNAME);
  }
}

function setJumpButtonVisibility(visible) {
  if (visible) {
    $jumpBtn.addClass(JUMP_BTN_VISIBLE_CLASSNAME);
  } else {
    $jumpBtn.removeClass(JUMP_BTN_VISIBLE_CLASSNAME);
  }
}
